<template>
  <div>
    <a-card style="margin-top:20px;">
      <TableView
        :columns="tableColumns"
        tableCardTitle="安华理达-查询"
        :scroll="{ x: 800 }"
        :data="tableData"
      >
        <template v-slot:radio="{ tableRow }">
          <a-radio-group v-model="value" @change="onChange">
            <a-radio :value="tableRow.id"></a-radio>
          </a-radio-group>
        </template>
      </TableView>
      <a-button
        type="danger"
        @click="handleFinicalSubmit"
        :disabled="disabled"
        :style="style"
      >
        财报更新申请
      </a-button>
      <a-button
        type="primary"
        @click="handleGoogolSubmit"
        :disabled="disabled"
        style="margin-left:10px;"
      >
        客户大数申请
      </a-button>
      <a-button
        type="primary"
        @click="handleDetailSubmit"
        :disabled="disabled"
        style="margin-left:10px;"
      >
        客户详财申请
      </a-button>

      <a-button type="primary" @click="handleCancel" style="margin-left:10px;">
        取消
      </a-button>
    </a-card>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import { mapGetters } from 'vuex'
import { geAnwaridaDetail, getFinicalSubmit } from '../../api'
import moment from 'moment'
export default {
  name: 'crm-report',

  data() {
    const tableColumns = [
      {
        width: 30,
        dataIndex: 'radio',
        title: '',
        scopedSlots: { customRender: 'radio' },
      },
      {
        width: 130,
        title: '客户编号',
        dataIndex: 'companyCode',
      },
      {
        width: 170,
        title: '客户名称',
        dataIndex: 'companyName',
      },
      {
        width: 220,
        title: '统一社会信用代码',
        dataIndex: 'creditCode',
      },
      {
        width: 220,
        title: '期望年份',
        dataIndex: 'hopeYear',
      },
      {
        width: 130,
        title: '最新财报年份(工商)',
        dataIndex: 'lastYear',
      },
      {
        width: 130,
        title: '最后更新时间',
        dataIndex: 'modifyTime',
      },
      {
        width: 140,
        title: '信息',
        dataIndex: 'message',
      },
    ]
    return {
      radio: '',
      value: '',
      disabled: true,
      tableData: [],
      tableColumns,
      hopeYear: '',
    }
  },
  components: {
    TableView,
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
  },
  mounted() {
    this._getCrmDetail()
  },
  methods: {
    // 财报更新申请
    async handleFinicalSubmit() {
      if (this.radio) {
        await getFinicalSubmit(this.radio)
        this.$message.success('成功')
      } else {
        this.$message.warning('请选择')
      }
    },
    onChange(e) {
      this.radio = e.target.value
      this.disabled = false
    },
    handleCancel() {
      this.$router.go(-1)
    },
    //   客户大数申请
    handleGoogolSubmit() {
      if (this.radio) {
        this.$router.push({
          name: 'mechanism-report-add',
          params: { customerId: this.$route.params.id },
          query: {
            googol: this.radio,
            hopeYear: this.hopeYear,
          },
        })
      } else {
        this.$message.warning('请选择')
      }
    },
    //客户详财申请
    handleDetailSubmit() {
      if (this.radio) {
        this.$router.push({
          name: 'mechanism-report-add',
          params: { customerId: this.$route.params.id },
          query: {
            detail: this.radio,
            hopeYear: this.hopeYear,
          },
        })
      } else {
        this.$message.warning('请选择')
      }
    },
    async _getCrmDetail() {
      try {
        const { id } = this.bureauReportBasicInfo
        const { data } = await geAnwaridaDetail(id)
        this.tableData = data
        this.hopeYear = data[0].hopeYear
        this.tableData.map(item => {
          if (item.message === '存在目标年份数据') {
            this.style = 'display:none;'
          }
          if (item.modifyTime) {
            item.modifyTime = moment(item.modifyTime).format('YYYY-MM-DD')
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
